import React from 'react';

import { themer } from '@spp/theme-provider';
import { ImageAsset } from '@spp/ui-image';

/* eslint react/prop-types: 0 */
const GalleryImage = ({ imageAsset, theme, ...rest }) => (
    <ImageAsset {...rest} {...imageAsset} theme={theme.image} />
);

export default themer('@spp/ui-gallery:image')(GalleryImage);



/** WEBPACK FOOTER **
 ** ./src/local-components/article/GalleryImage.js
 **/